import { useQuery } from '@tanstack/react-query';

import AuditLogs from '@/services/AuditLogs';

export const GET_AUDIT_ACTIONS_QUERY_KEY = ['audit-actions'];

export default function useGetAuditActions() {
  const { data, isFetching } = useQuery({
    queryKey: GET_AUDIT_ACTIONS_QUERY_KEY,
    queryFn: () => AuditLogs.getAuditActions(),
  });

  return {
    auditActions: data ?? [],
    isFetching,
  };
}
